import React, { CSSProperties, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { StudentTaskFragment } from '@school_ify/schoolify-repository/src/student/types';
import { useDeleteTaskMutation } from '@school_ify/schoolify-repository/src/shared/types';
import { useTaskToggleMutation } from '@school_ify/schoolify-repository/src/student_teacher/types';

import CheckBox from 'components/Input/CheckBox/ThemeCheckBox';
import BinTrash from 'components/Icons/BinTrash';
import Popover from 'components/Popover/Popover';
import studentAvatar from 'assets/student_avatar.svg';
import useOnClickOutside from 'hooks/useClickOutside';

import './TaskItem.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  task: StudentTaskFragment;
  // eslint-disable-next-line @typescript-eslint/ban-types
  refetchData?: () => void;
  onClick: (e) => void;
}

const TaskItem: React.FC<Props> = ({ style, task, refetchData, onClick }) => {
  const [showDeletePopover, setShowDeletePopOver] = useState(false);
  const { t } = useTranslation();
  const [selected, setSelected] = useState(task.is_completed);
  const deleteTaskButtonRef = useRef<HTMLDivElement>(null);
  const [taskToggleMutation] = useTaskToggleMutation();

  useOnClickOutside(deleteTaskButtonRef, () => setShowDeletePopOver(false));

  const [deleteTaskMutation] = useDeleteTaskMutation({
    variables: {
      id: task.id,
    },
    onCompleted() {
      refetchData();
    },
  });

  function toggleTheItem() {
    setSelected(!selected);
    const { is_completed } = task;
    taskToggleMutation({
      variables: {
        id: task.id,
        is_completed: !is_completed,
      },
      onCompleted() {
        refetchData();
      },
    });
  }

  function deleteTaskItem() {
    deleteTaskMutation();
  }

  const handleOpenDeletePopover = e => {
    setShowDeletePopOver(val => !val);
    e.stopPropagation();
  };

  return (
    <div className={`task-item-container ${selected ? 'selected' : ''}`} style={style}>
      <div className="inner-container">
        <div className="avatar" onClick={onClick}>
          <img src={studentAvatar} alt="student avatar" />
        </div>

        <div className="content">
          <div className="row" onClick={onClick}>
            <p>{task?.title || 'no title'}</p>
          </div>
          <div className="actions-container">
            <div onClick={e => handleOpenDeletePopover(e)} className={'cursor-pointer'}>
              <BinTrash fontSize={20} color="#213960" />

              {showDeletePopover && (
                <Popover ref={deleteTaskButtonRef}>
                  <p>
                    {t('common:AreYouSureYouWantToDelete')}
                    <span className={'text-bold ml-05'}>{task.title}</span>?
                  </p>
                  <div className={'flex w-full gap-1 mt-1 justify-between'}>
                    <button
                      onClick={deleteTaskItem}
                      className={'btn bg-primary border-none w-full border-radius-10px text-white '}
                    >
                      {t('chat:message_Tooltip.delete')}
                    </button>
                    <button
                      onClick={() => setShowDeletePopOver(val => !val)}
                      className={'btn bg-red border-none w-full border-radius-10px text-white '}
                    >
                      {t('common:cancel')}
                    </button>
                  </div>
                </Popover>
              )}
            </div>

            <div className="check-item no-hover-opacity">
              <CheckBox color="orange" round checked={selected} onChange={toggleTheItem} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskItem;
